var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-size-filter",style:(_vm.filterStyle),attrs:{"aria-label":"Select size"}},_vm._l((_vm.sortedOptions),function(size){return _c('button',{key:size,staticClass:"c-size-filter__option",class:{
      'c-size-filter__option--active': _vm.isActive(size)
    },attrs:{"role":"checkbox","aria-checked":_vm.isActive(size) ? true : false},on:{"click":function($event){return _vm.$emit('select', size)}}},[_vm._v("\n    "+_vm._s(size)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }